import { useMutation } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { throwOnError } from 'api/helpers';
import { queryClient } from 'configs/queryClient';
import useB2CServiceHistoryRequestQuery from 'hooks/useB2CServiceHistoryRequestQuery';

async function deleteB2CServiceDocument(apiClient: ApiClient, id: number) {
  return apiClient.DELETE('/op/v2/b2c-service-history-request/{id}/confirmation', { params: { path: { id } } });
}

export function useDeleteB2CServiceDocument(id: number) {
  const apiClient = useApiClient();

  return useMutation({
    mutationFn: () => throwOnError(deleteB2CServiceDocument(apiClient, id)),
    mutationKey: ['DeleteB2CServiceDocument', id],
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: useB2CServiceHistoryRequestQuery.getKey(id) });
    },
  });
}
